import React from 'react'
import Input from './Input'
import { connect } from 'react-redux'
import {
    clearFileDataForm,
    fileDataFormAddModel,
    fileDataFormAddSku,
    fileDataFormRemoveModel,
    fileDataFormRemoveSku,
    getAssetTypes,
    getProductAssetsForProduct,
    saveFileData,
    updateFileDataForm,
} from '../actions/UploadActions'
import IconButton from './IconButton'
import { SingleSelect } from './Select'
import { Chip, FormControlLabel, Switch, withStyles } from '@material-ui/core'

const styles = theme => ({
    iconButton: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit * 2,
    },
})

class FileDataForm extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            sku: '',
            model: '',
        }
    }

    componentDidMount() {
        const { getAssetTypes } = this.props
        getAssetTypes()
    }

    setLabel = label => this.props.updateFileDataForm({ label })
    setBrand = brand => this.props.updateFileDataForm({ brand })
    setAssetType = value => {
        this.props.updateFileDataForm({ assetType: value })
    }
    resetForm = () => {
        this.props.clearFileDataForm()
    }
    addSku = sku => {
        this.props.fileDataFormAddSku(sku)
        this.setState({ sku: '' })
    }
    addModel = model => {
        this.props.fileDataFormAddModel(model)
        this.setState({ model: '' })
    }
    removeSku = sku => this.props.fileDataFormRemoveSku(sku)
    removeModel = model => this.props.fileDataFormRemoveModel(model)
    setSku = sku => this.setState({ sku })
    setModel = model => this.setState({ model })

    onSubmit = () => {
        const { label, brand, skus, models, assetType, url } = this.props

        this.props.saveFileData({
            label,
            brand,
            skus,
            models,
            url,
            assetType: Number(assetType),
        })

        this.resetForm()

        if (this.props.onSubmit) {
            this.props.onSubmit()
        }
    }

    render() {
        const { sku, model } = this.state
        const { label, brand, assetType, skus, models, classes } = this.props
        const {
            setLabel,
            setBrand,
            addSku,
            addModel,
            removeSku,
            removeModel,
            setAssetType,
            setSku,
            setModel,
        } = this
        const {
            items: assetTypes,
            loading: loadingAssetTypes,
        } = this.props.assetTypes

        let assetTypesOptions = []

        for (const [value, label] of Object.entries(assetTypes)) {
            assetTypesOptions.push({ value: String(value), label })
        }

        let fileType = null

        if (assetType != null && assetTypes[String(assetType)] != null) {
            fileType = {
                label: assetTypes[String(assetType)],
                value: assetType,
            }
        }

        const skusChips = skus.map(s => {
            return <Chip key={s} label={s} onDelete={() => removeSku(s)} />
        })

        const modelChips = models.map(m => {
            return <Chip key={m} label={m} onDelete={() => removeModel(m)} />
        })

        return (
            <>
                {loadingAssetTypes ? (
                    <p>Ładuje</p>
                ) : (
                    <>
                        <div className="flex">
                            <SingleSelect
                                className="mt-8 mr-8 mb-16"
                                label="Rodzaj pliku"
                                id="file-form-type"
                                name="assetType"
                                value={fileType}
                                onChange={setAssetType}
                                options={assetTypesOptions}
                                fullWidth
                            />
                        </div>
                        <div className="flex">
                            <Input
                                className="mt-8 mb-16 mr-8"
                                required
                                label="Nazwa pliku (wyświetlana użytkownikowi)"
                                id="file-form-label"
                                name="label"
                                value={label}
                                onChange={e => setLabel(e.target.value)}
                                variant="outlined"
                                fullWidth
                            />
                        </div>
                        <div className="flex">
                            <Input
                                className="mt-8 mb-16 mr-8"
                                required
                                label="Marka"
                                id="file-form-brand"
                                name="brand"
                                value={brand}
                                onChange={e => setBrand(e.target.value)}
                                variant="outlined"
                                fullWidth
                            />
                        </div>
                        <div className="flex">{skusChips}</div>
                        <div className="flex">
                            <Input
                                className="mt-8 mb-16 mr-8"
                                required
                                label="Sku"
                                id="file-form-sku"
                                name="sku"
                                value={sku}
                                onChange={e => setSku(e.target.value)}
                                onKeyPress={e => {
                                    if (e.key === 'Enter') {
                                        addSku(sku)
                                    }
                                }}
                                variant="outlined"
                                fullWidth
                            />
                            <IconButton
                                className={classes.iconButton}
                                icon="add"
                                onClick={() => addSku(sku)}
                            />
                        </div>
                        <div className="flex">{modelChips}</div>
                        <div className="flex">
                            <Input
                                className="mt-8 mb-16 mr-8"
                                required
                                label="Model"
                                id="file-form-model"
                                name="model"
                                value={model}
                                onChange={e => setModel(e.target.value)}
                                onKeyPress={e => {
                                    if (e.key === 'Enter') {
                                        addModel(model)
                                    }
                                }}
                                variant="outlined"
                                fullWidth
                            />
                            <IconButton
                                className={classes.iconButton}
                                icon="add"
                                onClick={() => addModel(model)}
                            />
                        </div>
                        <div className="flex">
                            <IconButton
                                className="mt-8"
                                icon="save"
                                onClick={this.onSubmit}
                            >
                                Zapisz
                            </IconButton>
                        </div>
                    </>
                )}
            </>
        )
    }
}

const mapStateToProps = ({ presto }) => {
    const { productAssetTypes, upload } = presto
    const { url, brand, skus, models, assetType, label, loading } = upload

    return {
        assetTypes: productAssetTypes,
        url,
        brand,
        skus,
        models,
        label,
        assetType,
        loading,
    }
}

export default connect(mapStateToProps, {
    saveFileData,
    getAssetTypes,
    getProductAssets: getProductAssetsForProduct,
    updateFileDataForm,
    clearFileDataForm,
    fileDataFormAddSku,
    fileDataFormAddModel,
    fileDataFormRemoveSku,
    fileDataFormRemoveModel,
})(withStyles(styles, { withTheme: true })(FileDataForm))
